// Dil seçenekleri
export const LANGUAGE_OPTIONS = [
  { code: "tr-TR", name: "Türkçe (Türkiye)", flag: "🇹🇷" },
  { code: "en-US", name: "English (United States)", flag: "🇺🇸" },
  { code: "de-DE", name: "Deutsch (Deutschland)", flag: "🇩🇪" },
  { code: "fr-FR", name: "Français (France)", flag: "🇫🇷" },
  { code: "es-ES", name: "Español (España)", flag: "🇪🇸" },
  { code: "it-IT", name: "Italiano (Italia)", flag: "🇮🇹" },
  { code: "pt-PT", name: "Português (Portugal)", flag: "🇵🇹" },
  { code: "no-NO", name: "Norsk (Norge)", flag: "🇳🇴" },
];

// Tarayıcı dilini tespit etme fonksiyonu
export const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage || "tr-TR";
  
  // Eğer tam eşleşme varsa onu döndür
  const exactMatch = LANGUAGE_OPTIONS.find(lang => lang.code === browserLang);
  if (exactMatch) {
    return browserLang;
  }
  
  // Eğer sadece dil kodu eşleşirse (örn: 'tr' -> 'tr-TR')
  let tempCode = browserLang.split('-')[0];
  const langCode = tempCode === "nb" ? "no" : tempCode;
  const partialMatch = LANGUAGE_OPTIONS.find(lang => lang.code.startsWith(langCode));
  if (partialMatch) {
    return partialMatch.code;
  }
  
  // Hiç eşleşme yoksa default olarak Türkçe döndür
  return "tr-TR";
};

// Dil kodundan dil adını alma
export const getLanguageName = (code) => {
  const language = LANGUAGE_OPTIONS.find(lang => lang.code === code);
  return language ? language.name : code;
};

// Dil kodundan bayrak emoji'sini alma
export const getLanguageFlag = (code) => {
  const language = LANGUAGE_OPTIONS.find(lang => lang.code === code);
  return language ? language.flag : "🌐";
}; 